import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
/**
 * @description
 * The AsynchronousUtils class contains utility APIs that perform asynchronous operations using Observable patterns.
 */
class AsynchronousUtils {
  /**
   * This API obtains a new Observable that yields values based on the debounced delay interval provided.
   * @example <caption>In this example, the API obtains an Observable with a debounced interval of 200 milliseconds.</caption>
   * const sub = PCore.getAsynchronousUtils().getDebouncedSubject(200);
   * const subscription = sub.subscribe((argumentFromNext) => { \\ do something });
   * subscription.next(valueToSubscriber);
   * subscription.unsubscribe();
   *
   * @param delay The debounced time interval at which the Observable yields values.
   * @returns An Observable object
   * @function
   */

  getDebouncedSubject(delay: number) {
    return new Subject().pipe(debounceTime(delay));
  }
}
export default new AsynchronousUtils();
